import { render, staticRenderFns } from "./BajasComercialesModalVerDetalle.vue?vue&type=template&id=f05850f0&"
import script from "./BajasComercialesModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./BajasComercialesModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports